import type { ModalProps } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { Portal } from '../Portal';
import { StyledCloseButton, StyledModal } from './ExpandedImageModal.styles';

export interface ExpandedImageModalProps extends Omit<ModalProps, 'children' | 'onClose' | 'isOpen'> {
  onClose: () => void;
  isOpen: boolean;
  imgUrl: string;
  imgAlt: string;
}

export const ExpandedImageModal = ({ onClose, imgUrl, imgAlt, isOpen, ...props }: ExpandedImageModalProps) => {
  const CANCEL = I18n.t('js.common.modal.cancel');

  return (
    <>
      {isOpen && (
        <Portal>
          <StyledCloseButton
            label={CANCEL}
            iconName="x:regular"
            onPress={onClose}
            variant="text"
            color="secondary"
            size="xl"
          />
        </Portal>
      )}
      <StyledModal {...props} onClose={onClose} isOpen={isOpen}>
        <img src={imgUrl} alt={imgAlt} />
      </StyledModal>
    </>
  );
};
